import React, { Component } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { getTheme } from '../../global/utils';
import Modal from '../../components/modal/Modal';
import Heading from '../../components/text/Heading';
import Button from '../../components/buttons/Button';
import Loading from '../../components/loading/Loading';
import AlarmsChart from './AlarmsChart';
import AlarmsModalHeader from './AlarmsModalHeader';
import AlarmNoResults from './AlarmsNoResults';
import AlarmsSidePanel from './AlarmsSidePanel';

const ModalWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  .alarm-modal {
    &__main {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    &__content {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      position: relative;
      padding: ${getTheme('padding', 'verticalXL')} ${getTheme('padding', 'horizontalXL')};
      transition: width 0.3s;
      &.is-panel-open {
        width: calc(100% - 308px);
      }
    }
    &__content-inner {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: auto;
    }
    &__content-title {
      display: flex;
      align-items: baseline;
      margin-bottom: ${getTheme('marginBottom', 'l')};
      h3 {
        font-weight: 300;
      }
      button {
        margin-left: ${getTheme('spacer', 'l')};
        margin-bottom: 0;
      }
    }
    &__noresults {
      margin-top: auto;
      margin-bottom: auto;
      position: relative;
      top: -2.5rem; /* Optical centering fix */
    }
    &__sidepanel {
      height: 100%;
      flex-shrink: 0;
      border-left: 1px solid ${getTheme('black', '_800')};
      background-color: ${getTheme('textColor', 'white')};
    }
  }
  &.alarm-modal-loading {
    justify-content: center;
    align-items: center;
  }
`;

class AlarmsModal extends Component {
  constructor() {
    super();
    this.state = {
      isPanelOpen: false,
      chartCount: 0,
      charts: [],
    };
  }

  render() {
    let $this = this;
    let chartsList = this.props.charts.map(function(chart, index) {
      return (
        <AlarmsChart
          key={index}
          dataId={chart.id}
          cardTitle={
            <Heading level="heading5" nomargin>
              <h2>{chart.name}</h2>
            </Heading>
          }
          handleRemove={() => {
            $this.props.removeChart(chart.id);
          }}
          handleEdit={() => {
            $this.props.editChart(chart.id);
          }}
          vars={chart.vars}
          variablesValues={chart.values}
          chart_loading={chart.chart_loading}
        />
      );
    });
    let modalItem = {
      name: '',
      date: '',
      time: '',
      ut: '',
      sec: '',
      id: '',
      trigger: '',
      triggerId: '',
      crc: '',
      charts: '',
    };
    if (this.props.item) {
      modalItem = this.props.item;
    }
    let data_variables_lists = this.props.data_variables_lists;
    return (
      <Modal
        /* modalTitle={modalItem.alarms} */
        modalTitle="Snapshot Detail"
        isOpen={this.props.isOpen}
        contentLabel="Snapshot Detail"
        closeModal={this.props.closeModal}
        wontClose={this.props.wontClose}
        charts={this.props.charts}
      >
        {!this.props.loading && (
          <ModalWrapper>
            <div className="alarm-modal__main">
              <AlarmsModalHeader item={modalItem} />
              <div
                className={
                  'alarm-modal__content ' + (this.state.isPanelOpen ? 'is-panel-open' : '')
                }
              >
                <div className="alarm-modal__content-inner">
                  <div className="alarm-modal__content-title">
                    <Heading level="heading2">
                      <h3>Variable charts</h3>
                    </Heading>
                    {this.props.charts.length > 0 && (
                      <Button
                        secondary
                        onClick={this.props.addChart}
                        iconBefore={<FontAwesomeIcon icon={faPlus} />}
                      >
                        Add Chart
                      </Button>
                    )}
                  </div>
                  {!this.props.charts.length > 0 && (
                    <AlarmNoResults
                      className="alarm-modal__noresults"
                      handleClick={this.props.addChart}
                    />
                  )}
                  {this.props.charts.length > 0 && <div>{chartsList}</div>}
                </div>
              </div>
            </div>

            <AlarmsSidePanel
              handleClose={this.props.closePanel}
              handleUpdate={this.props.updateVars}
              updateChartName={this.props.updateChartName}
              removeVars={this.removeVars}
              className="alarm-modal__sidepanel"
              panelVisibility={this.props.isPanelOpen}
              panelChart={this.props.editableChart}
              data_variables_lists={data_variables_lists}
            />
          </ModalWrapper>
        )}
        {this.props.loading && (
          <ModalWrapper className="alarm-modal-loading">
            <Loading heading="Loading snapshot" text="It might take a while." />
          </ModalWrapper>
        )}
      </Modal>
    );
  }
}

export default AlarmsModal;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsModal.js